const isAcceptance = ['acc', 'localhost'].some((str) =>
  location.origin.includes(str)
);
const script = document.createElement('script');

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore -- will be replaced on build time. See esbuild.js
script.src = `https://sel-static${
  isAcceptance ? '.acc' : ''
}.persgroep.net/bookmarking/deploys/${encodeURIComponent(
  __TIMESTAMP__
)}/bookmarking.min.js`;
script.async = true;
script.onload = () => window.Bookmarking.init(window.APP.config.brandName);
document.head.appendChild(script);
